import { motion } from "framer-motion";

interface MoodChipProps {
  label: string;
  selected?: boolean;
  onClick?: () => void;
}

const MoodChip = ({ label, selected, onClick }: MoodChipProps) => (
  <motion.button
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={onClick}
    className={`px-5 py-3 rounded-full text-sm font-medium transition-all ${
      selected
        ? "bg-primary text-primary-foreground glow-blush"
        : "bg-secondary text-secondary-foreground hover:bg-primary/20 hover:text-primary"
    }`}
  >
    {label}
  </motion.button>
);

export default MoodChip;
